var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.offers),function(offer,index){return _c(_vm.componentName,{key:offer.offerKey,tag:"component",attrs:{"offer":offer,"data-cy":`flight-offer-${index}`},scopedSlots:_vm._u([{key:"price",fn:function(){return [_vm._t("price",null,{"offer":offer})]},proxy:true}],null,true)})}),_vm._v(" "),_c('flight-price-detail-modal')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }